var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{attrs:{"type":"flex","justify":"end"}},_vm._l((_vm.options),function(qr,i){return _c('el-button',{key:`emoji-${i}`,staticClass:"emoji-preview",attrs:{"circle":""},domProps:{"textContent":_vm._s(qr.text)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }